export default "__VITE_ASSET__CKPsruSW__"